<template>
    <div class="df-youtube df-youtube--16-9">
        <img class="d-none d-print-block" :src="`https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg`" alt="">
        <iframe class="d-block d-print-none" :src="`https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0&showinfo=0`" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
</template>

<script>
    export default {
        props: {
            youtubeId: String,
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .df-youtube {
        position: relative;
        width: auto;
        height: 0;
        padding-bottom: 100% / 16 * 9;

        iframe {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>
